import {Box, styled, ArrowBackIcon, Heading5, Body1, Body2, BackBtnWithDarkTheme, ButtonWithDarkTheme} from '../../../ui-library';

export const ContainerBox = styled(Box)`
    display: flex;
    flex-direction: column;
    width: 322px;
    height: 424px;
`;
export const BackIcon = styled(ArrowBackIcon)`
    align-self: center;
    font-size: 18px;
`;

export const Title = styled(Heading5)`
    ${({ theme }) => theme.typography.h5};
    margin-top: 4px;
    font-weight: 700;
    color: #FFFFFF;
`;

export const SubTitle = styled(Body1)`
    color: #FFFFFF;
    font-size: 14px;
    width: 100%;
    margin-top: 10px;
`;

export const ChosenImagesTitle = styled(Body2)`
    color:#9CA3AF;
    width: 100%;
    margin-top: 27px;
    margin-bottom: -13px;
`;

export const BackBtn = styled(BackBtnWithDarkTheme)`
    font-size: 12px;
    width: fit-content;
    height: fit-content;
`;

export const ContinueBtn = styled(ButtonWithDarkTheme)`
    font-size: 16px;
    width: fit-content;
    margin-top: 27px;
`;

